export default __webpack_public_path__ + "static/media/blog-8.31e98a20.jpg";